import { type FC } from 'react';
import {
  UiIconInfo
} from '@/lib/ui';
import Base, { type BaseProps } from './Base';

export type MessageBarInfoProps = Omit<BaseProps, 'icon'>;

export const MessageBarInfo: FC<MessageBarInfoProps> = (props) => {
  return (
    <Base
      textProps={{
        variant: 'body1'
      }}
      icon={<UiIconInfo size={'3xl'} color={'text.primary'} data-testid={'ui-icon'} />}
      bgColor={'blackAlpha.50'}
      {...props}
    />
  );
};

export default MessageBarInfo;
